class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const selectBtn = event.target.closest('.reward-select-btn');
    if (selectBtn) {
      const variantId = selectBtn.dataset.variantId;
      this.addReward(variantId);
      const modal = this.querySelector('#RewardModal');
      if (modal) modal.classList.remove('is-visible');
    }
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');


        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
        this.checkRewards();
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
    this.checkRewards();
  }

  checkRewards() {
    // Prevent multiple simultaneous operations
    if (this.isAddingReward || this.isRemovingReward) return;

    // Find the container to get the cart total
    const rewardContainer = this.querySelector('.cart-rewards-container');
    if (!rewardContainer) return;

    const total = parseInt(rewardContainer.getAttribute('data-total') || '0');

    // Find tiers data
    let tiers = [];
    let tiersScript = document.querySelector('#MiniCartRewardsData');

    if (tiersScript && tiersScript.textContent) {
      try {
        tiers = JSON.parse(tiersScript.textContent);
      } catch (e) { console.error('Error parsing tiers', e); }
    }

    if (tiers.length === 0) return;

    // --- REMOVAL LOGIC ---
    // Find all cart items and check if any reward items need to be removed
    const cartItems = this.querySelectorAll('[data-variant-id]');
    let rewardRemoved = false;

    cartItems.forEach(item => {
      if (rewardRemoved) return;

      const li = item.closest('li');
      if (!li) return;

      const variantId = parseInt(item.getAttribute('data-variant-id'));

      // Check if this is a reward item by looking for readonly input
      const readonlyInput = li.querySelector('input.quantity__input[readonly]');
      if (!readonlyInput) return; // Not a reward item

      const lineIndex = parseInt(readonlyInput.getAttribute('data-index'));

      // Find which tier this reward belongs to
      const tier = tiers.find(t => t.products.some(p => p.variant_id === variantId));

      if (tier && total < tier.threshold) {
        console.log('[MiniCart] Removing reward - total:', total, 'threshold:', tier.threshold);
        this.removeReward(lineIndex);
        rewardRemoved = true;
      }
    });

    if (rewardRemoved) return; // Stop if we triggered a removal, wait for re-render

    // --- ADDITION LOGIC ---
    const currentVariantIds = Array.from(cartItems).map(el => parseInt(el.getAttribute('data-variant-id')));

    let modalContent = '';
    let showModal = false;

    tiers.forEach(tier => {
      if (total >= tier.threshold) {
        // Check if any product from this tier is already in cart
        const hasReward = tier.products.some(p => currentVariantIds.includes(p.variant_id));

        if (!hasReward) {
          if (tier.products.length === 1) {
            this.addReward(tier.products[0].variant_id);
          } else if (tier.products.length > 1) {
            showModal = true;
            tier.products.forEach(p => {
              modalContent += `
                <div class="reward-product-item">
                   <img src="${p.image}" alt="">
                   <div class="product-info">
                       <div class="product-title">${p.title}</div>
                   </div>
                   <button type="button" class="select-btn reward-select-btn" data-variant-id="${p.variant_id}">Select</button>
                </div>
              `;
            });
          }
        }
      }
    });

    if (showModal) {
      const modalList = this.querySelector('#RewardModalList');
      if (modalList) {
        modalList.innerHTML = modalContent;
        this.querySelector('#RewardModal').classList.add('is-visible');
      }
    }
  }

  addReward(variantId) {
    // Prevent duplicate additions
    if (this.isAddingReward) return;
    this.isAddingReward = true;

    const body = JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1,
        properties: {
          '_reward': 'true'
        }
      }],
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body
    })
      .then((response) => response.json())
      .then((parsedState) => {
        this.isAddingReward = false;
        this.renderContents(parsedState);
      })
      .catch((e) => {
        this.isAddingReward = false;
        console.error(e);
      });
  }

  removeReward(lineIndex) {
    console.log('[MiniCart Rewards] removeReward called with lineIndex:', lineIndex);
    if (this.isRemovingReward) {
      console.log('[MiniCart Rewards] Already removing a reward, skipping');
      return;
    }
    this.isRemovingReward = true;

    const body = JSON.stringify({
      line: lineIndex,
      quantity: 0,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body
    })
      .then((response) => response.json())
      .then((parsedState) => {
        this.isRemovingReward = false;
        this.renderContents(parsedState);
      })
      .catch((e) => {
        this.isRemovingReward = false;
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
